function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/extensions/AutofocusExtension.ts";
import "core-js/modules/es.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "./autofocusExtension.css";
export var AutofocusExtension = /*#__PURE__*/function (_Autodesk$Viewing$Ext) {
  _inherits(AutofocusExtension, _Autodesk$Viewing$Ext);

  var _super = _createSuper(AutofocusExtension);

  function AutofocusExtension(viewer, options) {
    var _this;

    _classCallCheck(this, AutofocusExtension);

    _this = _super.call(this, viewer, options);

    _defineProperty(_assertThisInitialized(_this), "viewer", void 0);

    _defineProperty(_assertThisInitialized(_this), "options", void 0);

    _defineProperty(_assertThisInitialized(_this), "checkbox", void 0);

    _defineProperty(_assertThisInitialized(_this), "checkboxWrapper", void 0);

    _defineProperty(_assertThisInitialized(_this), "label", void 0);

    _this.viewer = viewer;
    _this.options = {
      onCheckboxClick: options.onCheckboxClick
    };
    _this.checkbox = document.createElement('input');
    _this.checkboxWrapper = document.createElement('div');
    _this.label = document.createElement('label');
    return _this;
  }

  _createClass(AutofocusExtension, [{
    key: "load",
    value: function load() {
      var _this2 = this;

      this.viewer.container.appendChild(this.checkboxWrapper);
      this.checkbox.addEventListener('change', function (e) {
        return _this2.onCheckBoxChange(e);
      });
      this.checkbox.setAttribute('type', 'checkbox');
      var label = document.createElement('label');
      label.classList.add('autoFocusCheckboxLabel');
      label.appendChild(document.createTextNode('Автофокус'));
      this.checkboxWrapper.appendChild(this.checkbox);
      this.checkboxWrapper.appendChild(label);
      this.checkboxWrapper.classList.add('autoFocus');
      return true;
    }
  }, {
    key: "onCheckBoxChange",
    value: function onCheckBoxChange(e) {
      var checkbox = e.target;

      if (checkbox) {
        this.options.onCheckboxClick({
          e: checkbox.checked
        });
      }
    }
  }, {
    key: "unload",
    value: function unload() {
      var _this3 = this;

      this.checkbox.removeEventListener('change', function (e) {
        return _this3.onCheckBoxChange(e);
      });
      Autodesk.Viewing.theExtensionManager.unregisterExtension('AutofocusExtension');
      return true;
    }
  }]);

  return AutofocusExtension;
}(Autodesk.Viewing.Extension);